// Valida que los campos no estén vacíos
const areTheFieldsFilled = (inputLists, btnLists) => {
  inputLists.forEach((inputs, index) => {
    const buttons = btnLists[index].map(btnId => document.querySelector(btnId))

    const checkFields = () => {
      const allFieldsFilled = inputs.every(inputId => {
        const input = document.querySelector(inputId)
        return input && input.value.trim() !== ''
      })

      buttons.forEach(button => {
        if (button) {
          button.disabled = !allFieldsFilled
          button.classList.toggle('btn-disabled', !allFieldsFilled)
        }
      })
    }

    inputs.forEach(inputId => {
      const input = document.querySelector(inputId)
      if (input) {
        input.addEventListener('input', checkFields)
      }
    })
  })
}

export default areTheFieldsFilled